export function getAllClasses(state) {
  return state.knownClasses || [];
}
